import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import classnames from 'classnames';

interface SimpleTooltipPrivateProps {
  Trigger: typeof TooltipPrimitive.Trigger;
  Content: React.FC<SimpleTooltipContentProps>;
  Arrow: typeof TooltipPrimitive.Arrow;
}

interface SimpleTooltipContentProps {
  side?: 'top' | 'bottom' | 'left' | 'right';
  sideOffset?: number;
  children: React.ReactNode;
  className?: string;
}

const SimpleTooltip: React.FC<TooltipPrimitive.TooltipProps> & SimpleTooltipPrivateProps = ({
  children,
  ...props
}) => (
  <TooltipPrimitive.Provider>
    <TooltipPrimitive.Root {...props}>{children}</TooltipPrimitive.Root>
  </TooltipPrimitive.Provider>
);

const SimpleTooltipContent: React.FC<TooltipPrimitive.TooltipContentProps> = ({
  side = 'top',
  sideOffset,
  children,
  className
}) => (
  <TooltipPrimitive.Content
    side={side}
    sideOffset={sideOffset}
    className={classnames(className, 'text-1 rounded border border-silver bg-white px-3 py-2')}
  >
    {children}
  </TooltipPrimitive.Content>
);

SimpleTooltip.Trigger = TooltipPrimitive.Trigger;
SimpleTooltip.Content = SimpleTooltipContent;
SimpleTooltip.Arrow = TooltipPrimitive.Arrow;

export default SimpleTooltip;
